import type { I18nOptions } from 'vue-i18n';

export const numberFormats: I18nOptions['numberFormats'] = {
  'de-DE': {
    currency: { currency: 'EUR', currencyDisplay: 'symbol', style: 'currency' },
    compactCurrency: {
      currency: 'EUR',
      currencyDisplay: 'symbol',
      style: 'currency',
      notation: 'compact',
    },
    unsetCurrency: { minimumFractionDigits: 2, maximumFractionDigits: 2, notation: 'compact' },
    compact: { notation: 'compact', compactDisplay: 'short' },
    percent: { style: 'percent', useGrouping: false },
    milliseconds: { style: 'unit', unit: 'millisecond', unitDisplay: 'narrow' },
    seconds: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
    minutes: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
    hours: { style: 'unit', unit: 'hour', unitDisplay: 'narrow' },
    days: { style: 'unit', unit: 'day', unitDisplay: 'narrow' },
    weeks: { style: 'unit', unit: 'week', unitDisplay: 'narrow' },
    months: { style: 'unit', unit: 'month', unitDisplay: 'narrow' },
    years: { style: 'unit', unit: 'year', unitDisplay: 'narrow' },
    storage: { notation: 'compact', style: 'unit', unit: 'byte', unitDisplay: 'narrow' },
  },
  'en-US': {
    currency: { currency: 'EUR', style: 'currency' },
    compactCurrency: { currency: 'EUR', style: 'currency', notation: 'compact' },
    unsetCurrency: { minimumFractionDigits: 2, maximumFractionDigits: 2, notation: 'compact' },
    compact: { notation: 'compact', compactDisplay: 'short' },
    percent: { style: 'percent', useGrouping: false },
    milliseconds: { style: 'unit', unit: 'millisecond', unitDisplay: 'narrow' },
    seconds: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
    minutes: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
    hours: { style: 'unit', unit: 'hour', unitDisplay: 'narrow' },
    days: { style: 'unit', unit: 'day', unitDisplay: 'narrow' },
    weeks: { style: 'unit', unit: 'week', unitDisplay: 'narrow' },
    months: { style: 'unit', unit: 'month', unitDisplay: 'narrow' },
    years: { style: 'unit', unit: 'year', unitDisplay: 'narrow' },
    storage: { notation: 'compact', style: 'unit', unit: 'byte', unitDisplay: 'narrow' },
  },
};
